import { render, staticRenderFns } from "./SoftwareLogHistory.vue?vue&type=template&id=39740424&scoped=true&"
import script from "./SoftwareLogHistory.vue?vue&type=script&lang=js&"
export * from "./SoftwareLogHistory.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLogHistory.vue?vue&type=style&index=0&id=39740424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39740424",
  null
  
)

export default component.exports